export const Education = [
  {
    period: "JUNE 26 2023 - PRESENT",
    title: "MASTER OF COMPUTER APPLICATION - ",
    place: "IGNOU - Thevara, Kochi",
    description: "Counting...",
  },
  {
    period: "JUNE 01 2019 - MARCH 01 2022",
    title: "BSC COMPUTER SCIENCE - ",
    place: "CALICUT UNIVERCITY",
    description: "CGPA : 7.65 (First Class with Distinction)",
  },
  {
    period: "JUNE 01 2017 - MARCH 01 2019",
    title: "COMPUTER SCIENCE - ",
    place: "KERALA HSE",
    description: "Percenage : 87%",
  },
  {
    period: "JUNE 01 2016 - MARCH 01 2017",
    title: "SSLC - ",
    place: "KERALA HSE",
    description: "Percenage : 97%",
  },
];
